import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/modules/auth/authProvider";
import LoggedUser from "@/modules/auth/components/LoggedUser";
import LanguageSwitcher from "@/modules/common/components/LanguageSwitcher";

export { PlayLayoutHeader };

function PlayLayoutHeader() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const userName: string = useMemo(() => {
    const nameChunks = [];
    if (user?.firstName) nameChunks.push(user?.firstName);
    if (user?.lastName) nameChunks.push(user?.lastName);

    return nameChunks.join(" ") || "";
  }, [user]);

  return (
    <AppBar color="primary" position="fixed">
      <Toolbar className="flex justify-between">
        <img
          className="cursor-pointer	"
          style={{ height: 32, padding: 1 }}
          src="/logoWithName.png"
          alt="Logo OGRE with name"
          onClick={() => navigate("/play")}
        />
        <Box className="flex items-center gap-4">
          <Typography
            className="grow"
            component="h1"
            variant="h6"
            color="#ffffff"
            noWrap
          >
            {userName}
          </Typography>
          <LoggedUser />
          <LanguageSwitcher />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
